import * as React from "react";
import { cn } from "../../../lib/utils";
import { Button } from "../button";

function SectionHeader({ title, description, action, actionLabel, onAction, className }) {
  return (
    <div
      className={cn(
        "mb-5 flex items-center justify-between gap-4 max-md:flex-col max-md:items-stretch",
        className,
      )}
    >
      <div>
        <h2 className="m-0 text-xl font-extrabold text-slate-800">{title}</h2>
        {description && (
          <p className="mt-1 text-sm text-muted-foreground">{description}</p>
        )}
      </div>
      {action ?? (actionLabel && onAction ? (
        <Button variant="add" onClick={onAction}>
          {actionLabel}
        </Button>
      ) : null)}
    </div>
  );
}

export { SectionHeader };
